import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import ArrowRight from "../../../images/arrow-right.svg"
import { useTranslateValue } from "../../../data/TranslateContext"

export default function SmoothieMangoCup(props) {
  const images = useStaticQuery(graphql`
    query cupImageSmoothieMangoCup {
      cupImageLarge: file(
        relativePath: { eq: "front-page-flavors/smoothie-mango-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageMedium: file(
        relativePath: { eq: "front-page-flavors/smoothie-mango-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 260) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageSmall: file(
        relativePath: { eq: "front-page-flavors/smoothie-mango-can.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 180) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const cupSources = [
    images.cupImageLarge.childImageSharp.fluid,
    {
      ...images.cupImageMedium.childImageSharp.fluid,
      media: `(max-width: 768px)`,
    },
    {
      ...images.cupImageSmall.childImageSharp.fluid,
      media: `(max-width: 540px)`,
    },
  ]

  const [{ language }] = useTranslateValue()

  return (
    <>
      <Img fluid={cupSources} />
      <div className="flavor-label">
        <h2>Mango Smoothie</h2>

        <Link to="/flavors" state={{ flavor: "smoothieMango" }}>
          {language === "en" && "Check out the details"}
          {language === "fr" && "Consultez les détails"}
          <ArrowRight />
        </Link>
      </div>
    </>
  )
}

const Svg = styled.svg`
  .active-bg-1 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .border {
    transition: all 0.2s ease-in-out;
    fill: ${props => (props.active ? "#185C2E" : props.theme.color.primary)};
  }
`
export function SmoothieMangoThumb(props) {
  const { active } = props

  return (
    <>
      {/* Mango */}
      <Svg
        version="1.1"
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="m76.016 47.858-0.56504 0.0029619c-4.3115 0-11.086 0.8174-15.997 4.74-4.1316 3.3003-6.2737 8.277-6.3711 14.796l-0.011109 3.2832-0.018317 2.1436-0.023551 1.6386c-0.22006 12.695-1.2097 15.623-3.6761 20.887l-1.2851 2.7245-0.38241 0.82427-0.60626 1.3363c-0.20884 0.46749-0.42457 0.95828-0.6476 1.4761-1.8374 4.6523-1.9248 8.0977-0.2432 10.199 2.125 2.6549 7.3911 3.5039 14.852 2.3987l0.4503-0.068659c10.118-1.583 28.103-7.957 34.877-32.851 2.4834-9.127 1.5815-17.625-2.54-23.929-3.1566-4.8833-8.2047-8.2215-13.92-9.2211l-0.52066-0.087911c-1.115-0.1862-2.2426-0.28414-3.3725-0.29306z"
          fill="#E5A128"
        />
        <path
          className="active-bg-1"
          d="m76.665 39.634-0.11024 0.79563-0.085396 0.67527c-0.11472 0.9477-0.23001 2.0772-0.31124 3.298l-0.032005 0.47545c0.42458 0.0077637 0.82475 0.022561 1.1969 0.042351l0.36087 0.020684 0.045124-0.19082c0.40749-1.6603 0.93902-3.2881 1.5903-4.8695l-2.6543-0.2471z"
          fill="#72BC81"
        />
        <path
          className="active-bg-1"
          d="m58.4 32.956c0.73527 3.1773 2.4309 6.0513 4.8564 8.2314 2.1435 1.8968 4.8899 2.9725 7.7515 3.0361-0.62606-2.514-2.1322-5.263-4.3644-7.4211-2.1308-2.0601-4.9233-3.5817-8.2435-3.8464z"
          fill="#72BC81"
        />
        <path
          className="border"
          d="m73.386 41.643 0.10932-0.95646c0.12131-0.98648 0.26636-1.9701 0.43503-2.95 0.14001-0.76403 0.84103-1.2941 1.6143-1.2207l6.0732 0.5654c0.47945 0.044735 0.90827 0.31692 1.1528 0.73173 0.24455 0.41481 0.27508 0.9218 0.082088 1.363-0.88004 1.9934-1.6043 4.0516-2.1663 6.1562 6.4267 1.1965 12.091 4.9826 15.654 10.487 4.5972 7.0322 5.6353 16.393 2.9233 26.357-7.1456 26.261-26.089 33.194-36.98 34.976l-0.32755 0.052436c-2.2162 0.36194-4.457 0.55264-6.7025 0.5704-5.4014 0-9.29-1.3467-11.406-3.9912-2.4033-3.0029-2.4663-7.45-0.1875-13.217l0.41961-0.96402 0.40045-0.89978 0.38237-0.84218c0.18685-0.4078 0.36733-0.79649 0.54205-1.1698l1.3675-2.9031 0.39595-0.86782 0.29198-0.66712c1.9795-4.6314 2.6201-8.6518 2.6201-24.388 0-7.707 2.5239-13.631 7.502-17.607 2.4826-1.9836 5.3441-3.2694 8.1822-4.0851-1.6253-0.63593-3.1423-1.5532-4.4778-2.7226-3.4657-3.0668-5.649-7.3265-6.1152-11.931-0.023394-0.40014 0.11434-0.79301 0.38246-1.091s0.64435-0.47618 1.0447-0.49495c7.6654-0.099374 14.334 4.7509 16.787 11.71zm2.6304 6.2147-0.56504 0.0029619c-4.3115 0-11.086 0.8174-15.997 4.74-4.1316 3.3003-6.2737 8.277-6.3711 14.796l-0.011109 3.2832-0.018317 2.1436-0.023551 1.6386c-0.22006 12.695-1.2097 15.623-3.6761 20.887l-1.2851 2.7245-0.38241 0.82427-0.60626 1.3363c-0.20884 0.46749-0.42457 0.95828-0.6476 1.4761-1.8374 4.6523-1.9248 8.0977-0.2432 10.199 2.125 2.6549 7.3911 3.5039 14.852 2.3987l0.4503-0.068659c10.118-1.583 28.103-7.957 34.877-32.851 2.4834-9.127 1.5815-17.625-2.54-23.929-3.1566-4.8833-8.2047-8.2215-13.92-9.2211l-0.52066-0.087911c-1.115-0.1862-2.2426-0.28414-3.3725-0.29306zm-23.645 59.55c0.33007 0.0156 0.65853 0.026033 0.9854 0.0313 0.82843 0.005799 1.4953 0.68207 1.4896 1.5105-0.0055303 0.7797-0.60491 1.4163-1.3661 1.4836l-0.16661 0.005855c-0.36-0.0049-0.7217-0.0176-1.0859-0.0352-0.81643-0.053485-1.4394-0.75136-1.4002-1.5686 0.03917-0.81724 0.72602-1.4523 1.5438-1.4275zm29.041-12.363c0.53504 0.031438 1.0127 0.34593 1.253 0.825 0.24029 0.47907 0.20675 1.05-0.087996 1.4976-3.563 5.41-12.335 11.761-23.176 12.92-0.053698 0.005929-0.10768 0.0091-0.1617 0.0091-0.796-0.002378-1.4515-0.62612-1.4934-1.421-0.041908-0.7949 0.5444-1.4841 1.3357-1.5702 10.544-1.1279 18.329-7.5479 20.989-11.588 0.29474-0.44764 0.80591-0.70402 1.3409-0.67259zm-4.7475-55.412-0.11024 0.79563-0.085396 0.67527c-0.11472 0.9477-0.23001 2.0772-0.31124 3.298l-0.032005 0.47545c0.42458 0.0077637 0.82475 0.022561 1.1969 0.042351l0.36087 0.020684 0.045124-0.19082c0.40749-1.6603 0.93902-3.2881 1.5903-4.8695l-2.6543-0.2471zm-18.265-6.6777c0.73527 3.1773 2.4309 6.0513 4.8564 8.2314 2.1435 1.8968 4.8899 2.9725 7.7515 3.0361-0.62606-2.514-2.1322-5.263-4.3644-7.4211-2.1308-2.0601-4.9233-3.5817-8.2435-3.8464z"
          fill="#185C2E"
        />
      </Svg>
    </>
  )
}
